/**
 * Criteria filters to fields.
 *
 * @param filters - Concatenated criteria filters.
 *
 * @public
 * @remarks
 * For filtering REQUEST_SERVER resources. Maps concatenated criteria filters
 * from a grid to a request fields object. Date/datetime groovy expressions will
 * append `_FROM` and `_TO` onto field names appropriately
 *
 * eg: converts
 *
 * ```
 * foo == 'bar' &&
 * asd == 'zxc' &&
 * Expr.containsIgnoreCase(FIELD, 'abc') &&
 * Expr.dateIsToday(DATE) &&
 * Expr.dateTimeIsGreaterEqual(DATETIME, '20231110-03:23') &&
 * Expr.dateTimeIsLessEqual(DATETIME, '20231115-03:23')
 * ```
 *
 * into
 *
 * ```
 * {
 *   foo: 'bar',
 *   asd: 'zxc',
 *   FIELD: '*abc*',
 *   DATE_FROM: '20231110-00:00',
 *   DATE_TO: '20231111-00:00',
 *   DATETIME_FROM: '20231110-03:23',
 *   DATETIME_TO: '20231115-03:23',
 * }
 * ```
 */
export function criteriaFiltersToFields(filters) {
    const criteria = filters.split('&&').map((s) => s.trim());
    const reqFields = {};
    criteria.forEach((c) => {
        if (c.startsWith('Expr')) {
            switch (c.match(/Expr\.(\w+)\(/)[1]) {
                case 'dateIsToday':
                    {
                        const fieldNameMatcher = /Expr\.dateIsToday\((\w+)\)/;
                        const [, fieldName] = c.match(fieldNameMatcher);
                        const date = new Date();
                        reqFields[`${fieldName}_FROM`] = `${date.toISOString().replace(/-/g, '').split('T')[0]}-00:00`;
                        date.setDate(date.getDate() + 1);
                        reqFields[`${fieldName}_TO`] = `${date.toISOString().replace(/-/g, '').split('T')[0]}-00:00`;
                    }
                    break;
                case 'dateTimeIsGreaterEqual':
                    {
                        const fieldNameValueMatcher = /Expr\.dateTimeIsGreaterEqual\((\w+), ?['"](.+)['"]\)/;
                        const [, fieldName, value] = c.match(fieldNameValueMatcher);
                        reqFields[`${fieldName}_FROM`] = value;
                    }
                    break;
                case 'dateTimeIsLessEqual':
                    {
                        const fieldNameValueMatcher = /Expr\.dateTimeIsLessEqual\((\w+), ?['"](.+)['"]\)/;
                        const [, fieldName, value] = c.match(fieldNameValueMatcher);
                        reqFields[`${fieldName}_TO`] = value;
                    }
                    break;
                case 'containsIgnoreCase':
                    {
                        const fieldNameValueMatcher = /Expr\.containsIgnoreCase\((\w+), ?['"](.+)['"]\)/;
                        const [, fieldName, value] = c.match(fieldNameValueMatcher);
                        reqFields[fieldName] = `*${value}*`;
                    }
                    break;
            }
        }
        else {
            const key = c.substr(0, c.indexOf('=')).trim().replace(/["']/g, '');
            const val = c
                .substr(c.lastIndexOf('=') + 1, c.length)
                .trim()
                .replace(/["']/g, '');
            reqFields[key] = val;
        }
    });
    return reqFields;
}
